import styled from 'styled-components';

const StyledQueryActionsHeader = styled.div`
  min-height: 43px;
  padding-top: ${props => props.theme.spacing.small};
  padding-bottom: ${props => props.theme.spacing.small};
`;

const StyledAtLeastNumber = styled.div`
  width: 70px;
  input {
    border-color: ${props => !props.error && props.colors && props.colors[0]};
  }
  input:focus {
    border-color: ${props => !props.error && props.colors && props.colors[0]};
  }
`;

export { StyledQueryActionsHeader, StyledAtLeastNumber };
